<script>
  /**Components*/
  import NavigationMobile from "$lib/components/layout/header/NavigationMobile.svelte";
  import HeaderCart from "./HeaderCart.svelte";
  import FreeShippingBanner from "$lib/components/cart/FreeShippingBanner.svelte";
  import Logo from "$lib/components/layout/Logo.svelte";

  /**@type {boolean}*/
  export let isOpen = false;
</script>

<label class="burger" for="burger" class:open={isOpen}>
  <input type="checkbox" id="burger" bind:checked={isOpen} />
  <span></span>
  <span></span>
  <span></span>
</label>

<div class="menu-mobile" id="mobile-menu" class:active={isOpen}>
  <div class="content-container">
    <div class="free-shipping">
      <FreeShippingBanner />
    </div>
    <div class="top-menu">
      <div class="burger-button">
        <label class="burger" for="burger" class:open={!isOpen}>
          <input type="checkbox" id="x-burger" bind:checked={isOpen} />
          <span></span>
          <span></span>
          <span></span>
        </label>
      </div>
      <div class="logo">
        <Logo bind:isOpen />
      </div>
      <div class="icon-container">
        <div class="shopping-bag">
          <HeaderCart />
        </div>
      </div>
    </div>
    <div class="content-menu">
      <NavigationMobile bind:isOpen />
    </div>
  </div>
</div>

<style>
  .burger {
    position: relative;
    width: 27px;
    height: 20px;
    background: transparent;
    cursor: pointer;
    display: block;
    z-index: 9999999999;
    opacity: 1;
  }
  .burger.open {
    opacity: 0;
  }
  .burger input {
    display: none;
  }
  .burger span {
    display: block;
    position: absolute;
    height: 2.5px;
    width: 100%;
    background: #1f2525;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
  }
  .burger span:nth-of-type(1) {
    top: 0px;
    transform-origin: left center;
  }
  .burger span:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);
    transform-origin: left center;
  }
  .burger span:nth-of-type(3) {
    top: 100%;
    transform-origin: left center;
    transform: translateY(-100%);
  }
  .burger input:checked ~ span:nth-of-type(1) {
    transform: rotate(45deg);
    top: 0px;
    left: 5px;
  }
  .burger input:checked ~ span:nth-of-type(2) {
    width: 0%;
    opacity: 0;
  }
  .burger input:checked ~ span:nth-of-type(3) {
    transform: rotate(-45deg);
    top: 20px;
    left: 5px;
  }
  .menu-mobile {
    background-color: #f6f6f6;
    width: 0;
    height: 100vh;
    min-height: 100svh;
    max-height: 100vh;
    transition: all 500ms ease;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999999;
    overflow: hidden;
    opacity: 0;
  }
  .menu-mobile.active {
    width: 100svw;
    opacity: 1;
  }
  .menu-mobile > .content-container {
    min-width: 100svw;
    height: 100%;
    overflow: hidden;
    opacity: 0;
    transition: all 200ms ease;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .menu-mobile.active .content-container {
    opacity: 1;
  }
  .free-shipping {
    width: 100%;
  }
  .top-menu {
    display: grid;
    grid-template-columns: 34px 1fr 34px;
    padding: 0 10px;
    width: 100%;
    min-height: 65px;
    align-items: center;
    justify-items: center;
    justify-content: center;
  }

  .content-menu {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
